import { render, staticRenderFns } from "./CopyOfferButtonNew.vue?vue&type=template&id=4644701c&scoped=true"
import script from "./CopyOfferButtonNew.vue?vue&type=script&lang=ts"
export * from "./CopyOfferButtonNew.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4644701c",
  null
  
)

export default component.exports